import React, { useEffect } from 'react'
import { Row, Col } from 'antd'
import { useDispatch } from 'react-redux'
import { routersHelper, putHttpLog, getCookie } from '../../helpers'
import { SET_POPUP_STATUS } from '../../redux/actions/type';
import { isEmpty } from 'lodash'

const ErrorByCase = ({ t }) => {
    const dispatch = useDispatch()
    const { useRouter } = routersHelper
    const router = useRouter()
    const { query: { message, setLog } } = router

    useEffect(() => {
        const redirectPage = () => {
            window.location.href = `${window._env_.vRoomUrl}/portal`
        }
        dispatch({
            type: SET_POPUP_STATUS,
            payload: {
                status: 'error',
                isShow: true,
                body: message,
                action: () => redirectPage()
            }
        })
    }, [dispatch, message, t, router])

    useEffect(() => {
        const fetchLog = async () => {
            const errorObj = getCookie('error') ? JSON.parse(getCookie('error')) : {}
            if (setLog && !isEmpty(errorObj)) {
                await putHttpLog(errorObj)
            }
        }
        fetchLog()
    }, [setLog])

    return (
        <>
            <Row className="container">
                <Col span={24}>
                    <div className="sec1">
                        <Row type="flex" justify="center">
                            <Col lg={2} xs={5}>
                                {/* eslint-disable-next-line */}
                                <img src={process.env.PUBLIC_URL + '/img/logo_footer_tvw.png'} style={{ width: '100%' }} />
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default ErrorByCase
